import Vue from 'vue'
import Router from 'vue-router'
import feedback from "./views/feedback"
import order from './views/order'
import search from './views/search'
import spec from "./views/spec"
const tutorial = () => import("./views/tutorial")
import preview from "./views/preview"
const addressManage = () => import("./views/AddressManage")
const orderEtc = () => import("./views/orderEtc")
import hot from "./views/hot"
const guide = () => import("./views/guide")
const etcDetail = () => import("./views/etcDetail")
const orderPrint = () => import("./views/orderPrint")
const print = () => import("./views/print")
import customerService from "./views/customerService"
const combinePay = () => import("./views/CombinePay")
const orderDetail = () => import("./views/OrderDetail")
const PayResult = () => import("./views/PayResult")
const printNotice = () => import("./views/PrintNotice")
import agreement from "./views/agreement"
import OrderList from "./views/OrderList"
const weddingEdit = () => import("./views/edit")
const addPrint = () => import("./views/AddPrint")
Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'order',
      component: order,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '搜索规格'
      }
    },
    {
      path: '/spec',
      name: 'spec',
      component: spec,
      meta: {
        title: '规格详情'
      }
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial,
      meta: {
        title: '教程'
      }
    },
    {
      path: '/preview',
      name: 'preview',
      component: preview,
      meta: {
        title: '选择背景'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/address-manage',
      name: 'addressManage',
      component: addressManage,
      meta: {
        title: '地址管理'
      },
    },
    {
      path: '/orderEtc',
      name: 'orderEtc',
      component: orderEtc,
      meta: {
        title: '我的电子照'
      }
    },
    {
      path: '/hot',
      name: 'hot',
      component: hot,
      meta: {
        title: '热门规格'
      }
    },
    {
      path: '/guide',
      name: 'guide',
      component: guide,
      meta: {
        title: '操作指南'
      }
    },
    {
      path: '/etcDetail',
      name: 'etcDetail',
      component: etcDetail,
      meta: {
        title: '电子照订单'
      }
    },
    {
      path: '/OrderList',
      name: 'OrderList',
      component: OrderList,
      meta: {
        title: '我的冲印照'
      }
    },
    {
      path: '/print',
      name: 'print',
      component: print,
      meta: {
        title: '冲印'
      }
    },
    {
      path: '/customerService',
      name: 'customerService',
      component: customerService,
      meta: {
        title: '联系客服'
      }
    },
    {
      path: '/combine-pay',
      name: 'combinePay',
      component: combinePay,
      meta: {
        title: '合并支付'
      },
    },
    {
      path: '/order-detail/:order_id',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '订单详情',
      }
    },
    {
      path: '/mix-order-detail/:order_id',
      name: 'mixOrderDetail',
      component: () => import(/* webpackChunkName: "order_detail" */ './views/OrderDetailMixed.vue'),
      meta: {title: "订单详情"},
    },
    {
      path: '/pay-success',
      name: 'paySuccess',
      component: PayResult,
      meta: {title: '支付成功'}
    }, {
      path: '/pay-fail',
      name: 'payFailed',
      component: PayResult,
      meta: {title: '支付失败'}
    },
     {
      path: '/print-notice',
      name: 'printNotice',
      component: printNotice,
      meta: {title: '冲印须知'}
    },
	{
	  path: '/feedback',
    name: 'feedback',
    component:feedback,
	  // component: resolve => {
	  //   require(['./views/feedback'], resolve)
	  // },
	  meta: {title: '反馈与建议'}
  },
  {
    path: '/agreement',
    name: 'agreement',
    component:agreement,
    meta:{title:'隐私协议'}
  },
  {
    path:'/weddingEdit',
    name: 'weddingEdit',
    component:weddingEdit,
    meta:{title:'结婚登记照'}
  },
  {
    path:'/addPrint',
    name:'addPrint',
    component:addPrint,
    meta:{title:'加印证件照'}
  },
    {
      path: '*',
      redirect: '/'
    },
  ]
})